import clsx from "clsx";
import Chips from "./Chips";
import { CompareSetRow } from "./@types";
import styles from "./compare-samples.module.scss";

interface SetRowProps {
  row: CompareSetRow;
}

const SetRow = ({ row }: SetRowProps): JSX.Element => (
  <div className={styles.row}>
    <div className={styles.label}>
      <span
        className={clsx(styles.marker, {
          [styles["marker--differs"]]: row.differs
        })}
      />
      <div>
        {row.label}
        <div className={styles.summary}>
          {row.shared} in both · {row.onlyMain} only left · {row.onlyOther} only
          right
        </div>
      </div>
    </div>
    <div className={styles.value}>
      <Chips chips={row.mainChips} side="main" />
    </div>
    <div className={styles.value}>
      <Chips chips={row.otherChips} side="compared" />
    </div>
  </div>
);

export default SetRow;
